import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider, Link } from '@mui/material';

const CookieUsage: React.FC = () => {
  const browserLinks = [
    {
      browser: "Internet Explorer",
      link: "https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
    },
    {
      browser: "Firefox",
      link: "https://support.mozilla.org/pt-BR/kb/gerenciar-os-cookies"
    },
    {
      browser: "Safari",
      link: "https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
    },
    {
      browser: "Google Chrome",
      link: "https://support.google.com/chrome/answer/95647?hl=pt-BR"
    },
    {
      browser: "Microsoft Edge",
      link: "https://support.microsoft.com/pt-br/help/4027947/microsoft-edge-delete-cookies"
    },
    {
      browser: "Opera",
      link: "https://help.opera.com/pt-br/latest/web-preferences/#cookies"
    }
  ];

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        11. Uso de Cookies ou Dados de Navegação pela INNOVA PLANO DE SAÚDE
      </Typography>

      <Typography paragraph>
        A INNOVA PLANO DE SAÚDE LTDA utiliza cookies, que consistem em arquivos de texto enviados pela plataforma ao dispositivo do usuário, nos quais são armazenadas informações relacionadas à navegação no site. Esses cookies são empregados com o objetivo de melhorar a experiência do usuário e otimizar as funcionalidades disponibilizadas.
      </Typography>

      <Typography paragraph>
        Ao acessar o site da INNOVA PLANO DE SAÚDE e consentir com o uso de cookies, o usuário manifesta ciência e concordância quanto à coleta de dados de navegação por meio desse mecanismo.
      </Typography>

      <Typography paragraph>
        O usuário tem o direito de, a qualquer momento e sem ônus, alterar as permissões relacionadas ao uso de cookies, bem como bloqueá-los ou recusá-los. Entretanto, é importante destacar que a revogação do consentimento para determinados tipos de cookies poderá comprometer o funcionamento pleno de algumas funcionalidades da plataforma.
      </Typography>

      <Typography paragraph>
        A gestão dos cookies pode ser realizada diretamente nas configurações do navegador utilizado, na seção destinada ao gerenciamento de cookies. Para instruções específicas sobre como realizar esse procedimento, recomendamos consultar a área de suporte ou configurações do navegador, tutoriais sobre o tema diretamente nos links abaixo:
      </Typography>

      <List>
        {browserLinks.map((browser, index) => (
          <React.Fragment key={index}>
            <ListItem>
              <ListItemText
                primary={
                  <Typography variant="body1">
                    Se você usa o {browser.browser}:{' '}
                    <Link href={browser.link} target="_blank" rel="noopener noreferrer">
                      {browser.link}
                    </Link>
                  </Typography>
                }
              />
            </ListItem>
            {index < browserLinks.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </div>
  );
};

export default CookieUsage;
